/** Mixpanel event names shared across hive + marketplace clients. */
export const MIXPANEL_EVENTS = {
  PAGE_VIEW: 'Page View',
  WAITLIST_MODAL_OPEN: 'Waitlist Modal Open',
  WAITLIST_SIGNUP: 'Waitlist Signup',
  LIVE_WITH_US_CLICK: 'Live With Us Click',
  PROSPECT_LOGIN: 'Prospect Login',
  PRE_APPLICATION_COMPLETE: 'Pre-Application Complete',
} as const;

export type MixpanelSite = 'hive' | 'marketplace';
